import CardFields from "@/components/Spellify/CardFields/CardFields";
import { formatBackgroundURL } from "@/lib/urlBackgroundFormat";
import styles from './Card.module.scss'
import { ScryfallCard } from "@scryfall/api-types";
import classNames from "classnames";

type Props = {
  card: ScryfallCard.Normal,
  typeParts: string[],
  oracleTextParts: string[],
  correctGuesses: string[],
  revealCard?: boolean,
  isHardMode?: boolean,
}

const Card = ({
  card,
  oracleTextParts,
  correctGuesses,
  typeParts,
  revealCard=false,
  isHardMode=false,
}: Props) => {

    return (
      <div className={styles.cardOuter}>
        <div className={styles.card}>
          <img alt="card frame" className={classNames(styles.image, isHardMode && styles.hardMode)} src={`https://json.edhrec.com/static/public/img/${formatBackgroundURL(card, isHardMode)}`}/>
          {!revealCard && <CardFields
            card={card}
            oracleTextParts={oracleTextParts}
            typeParts={typeParts}
            correctGuesses={correctGuesses}
            isHardMode={isHardMode}
          />
          }
        </div>
      </div>
    )
    
}

export default Card